import { ThemeSwitcher as SharedThemeSwitcher } from '@speaking-coach/ui'

export function ThemeSwitcher({ surface = 'card', showLabel = false }: { surface?: 'app' | 'card'; showLabel?: boolean }) {
  return <SharedThemeSwitcher showLabel={showLabel} surface={surface} labels={{ label: 'Appearance', light: 'Light', dark: 'Dark', system: 'System' }} />
}
